import React, { useState } from 'react';
import './Library.css';
import '@fontsource/inter';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';

function Library() {
    return (
        <section className="container">
            <CurrentTime />
            <DynamicIsland />
            <Back />

            <div className="library-container">
            </div>

            
        </section>
    );
}

export default Library;
